import { gql } from '@common/hooks';
import { SupplierType } from '@institutions/types';

export const UpdateSupplierDepartmentsMutation = gql`
  mutation UpdateSupplierDepartments(
    $supplierId: String!
    $input: UpdateSupplierDepartmentsInput!
  ) {
    updateSupplierDepartments(supplierId: $supplierId, input: $input) {
      supplier {
        id
      }
    }
  }
`;

export type UpdateSupplierDepartmentsResponse = {
  updateSupplierDepartments: {
    supplier: Partial<SupplierType>[];
  } | null;
};

export type UpdateSupplierDepartmentsVariables = {
  supplierId: string;
  input?: {
    organizationUnitIds?: string[];
    rejectSubmissions?: boolean;
    retractExtensionOffers?: boolean;
    retractOffers?: boolean;
    notes?: string;
    tierId?: string;
    roleIds: string[];
  };
};
